import React, { useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaTachometerAlt, FaBox, FaSignOutAlt } from 'react-icons/fa';
import { UserContext } from '../App.js';

const SupplierSidebar = () => {
    // Get the user object from the context
    const { logout } = useContext(UserContext);
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    // Use optional chaining to safely get the last name
    // const DeliveryName = user?.lastName || 'Livreur';

    return (
        <nav className="bg-gray-900 text-gray-300 w-64 min-h-screen p-6 flex flex-col shadow-xl">
            <div className="flex items-center justify-center mb-10">
                {/* Use the supplier's last name in the title */}
                <Link to="/supplier-dashboard" className="text-white text-3xl font-extrabold tracking-wide">
                    {/* <span className="text-indigo-400">{DeliveryName}</span> Panel */}
                    <span className="text-indigo-400">Livreur</span> Panel
                </Link>
            </div>
            <ul className="flex-grow space-y-3">
                <li>
                    <Link
                        to="/delivery-dashboard"
                        className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/delivery-dashboard')
                            ? 'bg-indigo-700 text-white font-bold'
                            : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'
                            }`}
                    >
                        <FaTachometerAlt className="w-5 h-5" />
                        <span className="font-medium">Tableau de bord</span>
                    </Link>
                </li>
                <li>
                    <Link
                        to="/delivery/delivery"
                        className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/delivery/delivery')
                            ? 'bg-indigo-700 text-white font-bold'
                            : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'
                            }`}
                    >
                        <FaBox className="w-5 h-5" />
                        <span className="font-medium">Mes Livraisons</span>
                    </Link>
                </li>
             
            </ul>
            <div className="mt-auto pt-4 border-t border-gray-700">
                <button
                    onClick={handleLogout}
                    className="w-full flex items-center space-x-4 p-3 rounded-lg text-red-400 hover:bg-red-900 transition-colors duration-200"
                >
                    <FaSignOutAlt className="w-5 h-5" />
                    <span className="font-medium">Déconnexion</span>
                </button>
            </div>
        </nav>
    );
};

export default SupplierSidebar;